export const formatDate = (dateString) => {
  if (!dateString) return 'Not recorded';
  const date = new Date(dateString);
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 
                  'July', 'August', 'September', 'October', 'November', 'December'];
  return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
};

export const formatDateShort = (dateString) => {
  if (!dateString) return 'Not recorded';
  const date = new Date(dateString);
  return `${date.getDate()} ${date.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })}`;
};

export const formatMileage = (value, unit) => {
  if (!value) return 'Not recorded';
  return `${parseInt(value).toLocaleString()} ${unit?.toLowerCase() || 'miles'}`;
};
